export class EventBus {
    listeners = new Set();
    on(fn) {
        this.listeners.add(fn);
        return () => this.off(fn);
    }
    off(fn) {
        this.listeners.delete(fn);
    }
    emit(e) {
        for (const fn of this.listeners) {
            try {
                fn(e);
            }
            catch {
                // ignore
            }
        }
    }
}
export const events = new EventBus();
//# sourceMappingURL=events.js.map